import NavMenuLinks from '../headers/NavMenuLinks'

function FooterNav({ items, layout = 'row', variant = 'light' }) {
  if (!items?.length) return null
  const getLabel = (item) => item.label || ''

  return (
    <nav className={`footer-nav footer-nav--${layout} footer-nav--${variant}`} aria-label="Footer">
      <NavMenuLinks items={items} getLabel={getLabel} />
    </nav>
  )
}

export default FooterNav
